<template>
    <div class="wrap">
        <div class="boxCard">
            <el-card class="box-card" :body-style="{padding: '0'}">
                <div slot="header" class="clearfix">
                    <span>岗下员工</span>
                    <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
                </div>
                <el-form :inline="true" :model="queryParams" class="demo-form-inline">
                    <el-form-item label="员工姓名">
                        <el-input v-model="queryParams.value" placeholder="请输入员工姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="部门">
                        <el-select v-model="queryParams.value" placeholder="请选择部门">
                            <el-option label="区域一" value="shanghai"></el-option>
                            <el-option label="区域二" value="beijing"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary">查询</el-button>
                    </el-form-item>
                </el-form>
            </el-card>
        </div>
        <div class="tabBox">
            <el-card class="box-card" :body-style="{padding: '0'}">
                <div slot="header">
                    <span class="tabTitle">员工列表</span>
                    <el-button type="primary">添加账户</el-button>
                </div>
                <el-table :data="tableData" show-header border style="width: 100%">
                    <el-table-column type="index" align="center" label="序号" />
                    <el-table-column prop="test" align="center" label="员工姓名" />
                    <el-table-column prop="test" align="center" label="登录账户" />
                    <el-table-column prop="test" align="center" label="手机号码" />
                    <el-table-column prop="test" align="center" label="部门" />
                    <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
                            <!-- <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button> -->
                            <!-- <el-button size="mini" @click="isShow = true">编辑</el-button> -->
                            <el-button size="mini" type="danger">移除</el-button>
                            <!-- <el-button size="mini" type="primary" @click="isShow = true">新增下级部门</el-button> -->
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
            <el-pagination :current-page.sync="pageNum" :page-size="pageSize" @size-change="barSizeChange" @current-change="barCurrentChange" :page-sizes="[10, 20, 30, 40, 50]" background="" layout="sizes, prev, pager, next" :total="totalCount"></el-pagination>
        </div>
        <my-from-dialog :isShow="isShow" title="提示11" @cancel="closeDialog" @ok="okDialog" @closeCallBack="closeCbDialog" :scrollHeight="300" :dialogWidth="'500px'" :cancelBtn="true" :okBtn="true">
            <template slot="froms">
                <div>
                    <el-form :model="form" label-width="100px">
                        <el-form-item label="上级机构">
                            <el-select v-model="form.value" placeholder="请选择活动区域" class="baseInp">
                                <el-option label="区域一" value="shanghai"></el-option>
                                <el-option label="区域二" value="beijing"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="机构名称">
                            <el-input v-model="form.value" class="baseInp"></el-input>
                        </el-form-item>
                        <el-form-item label="类型">
                            <el-select v-model="form.value" placeholder="请选择活动区域" class="baseInp">
                                <el-option label="区域一" value="shanghai"></el-option>
                                <el-option label="区域二" value="beijing"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="备注">
                            <el-input v-model="form.value" :rows="5" type="textarea" class="baseInp"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </template>
        </my-from-dialog>
    </div>
</template>

<script>
import myFromDialog from '@/components/common/from_dialog';
export default {
    components: {
        myFromDialog
    },
    computed: {},
    watch: {},
    data() {
        return {
            isShow: false,
            pageNum: 1,
            pageSize: 10,
            totalCount: 0,
            queryParams: {
                value: '',
            },
            form: {
                value: '',
            },
            tableData: [{ test: 'test' }]
        }
    },
    created() {
        // this.getPrescriptionDetailInfo();
    },
    methods: {
        closeDialog(data) {
            this.isShow = false;
            console.log(data);
        },
        okDialog(data) {
            console.log(data);
            this.isShow = false;
            // this.isShow = false;
        },
        closeCbDialog(data) {
            console.log(data);
            this.isShow = false;
        },

        // 当前显示条数
        barSizeChange(val) {
            this.form.pageSize = val;
            this.getPrescriptionDetailInfo();
            console.log(`每页 ${val} 条`);
        },
        // 当前页
        barCurrentChange(val) {
            this.form.pageNum = val;
            this.getPrescriptionDetailInfo();
            console.log(`当前页: ${val}`);
        },
    },
}
</script>

<style lang="less" scoped>
.wrap {
    background: #fff;
}
.queryBox {
    // background: #fff;
    padding: 20px;
}
.baseInp {
    width: 300px;
}

.tabTitle {
    color: #333;
    font-size: 15px;
    margin-right: 30px;
}
</style>
